import { loadImage } from '../util/image'

class LoaiDuAn {
  private ten
  private hinhAnh
  private url
  private duAn
  constructor(options) {
    this.ten = options.ten
    this.hinhAnh = options.jsonb_content
      ? loadImage(options.jsonb_content.hinh_anh)
      : ''
    this.url = options.url
    this.duAn = options.du_an
  }
}

export default LoaiDuAn
